"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TriangleWarning_exports = {};
__export(TriangleWarning_exports, {
  default: () => TriangleWarning_default
});
module.exports = __toCommonJS(TriangleWarning_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M11 13.0042V7.00415C11 6.45415 11.45 6.00415 12 6.00415C12.55 6.00415 13 6.45415 13 7.00415V13.0042C13 13.5542 12.55 14.0042 12 14.0042C11.45 14.0042 11 13.5542 11 13.0042ZM12 15.0042C11.17 15.0042 10.5 15.6742 10.5 16.5042C10.5 17.3342 11.17 18.0042 12 18.0042C12.83 18.0042 13.5 17.3342 13.5 16.5042C13.5 15.6742 12.83 15.0042 12 15.0042ZM23.58 19.8841C22.88 21.2341 21.41 22.0042 19.57 22.0042H4.44C2.59 22.0042 1.13 21.2341 0.429996 19.8841C-0.280004 18.5241 -0.0800042 16.7842 0.929996 15.3242L8.97 2.60415C9.68 1.58415 10.8 1.00415 12 1.00415C13.2 1.00415 14.32 1.58415 15 2.57415L23.08 15.3442C24.09 16.8042 24.28 18.5341 23.57 19.8841H23.58ZM21.43 16.4641C21.43 16.4641 21.41 16.4442 21.41 16.4242L13.34 3.67415C13.05 3.26415 12.55 3.00415 12 3.00415C11.45 3.00415 10.95 3.26415 10.64 3.71415L2.59 16.4242C1.97 17.3041 1.83 18.2642 2.19 18.9542C2.54 19.6342 3.34 20.0042 4.43 20.0042H19.55C20.64 20.0042 21.44 19.6342 21.79 18.9542C22.15 18.2642 22.01 17.3041 21.42 16.4641H21.43Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgTriangleWarning = SvgIcon;
var TriangleWarning_default = SvgTriangleWarning;
//# sourceMappingURL=TriangleWarning.js.map